export class BdPermissionsUsersStore {

  constructor(
    private readonly _baseUrl: string
  ) {
  }

  public base(): string {
    return this._baseUrl;
  }

  public byId(userId: string): string {
    return `${this.base()}/users/${userId}`;
  }
}
